import { generateApiActions } from './action-helpers';

const types = {
  FETCH_ATTACHMENTS: 'FETCH_ATTACHMENTS',
  REMOVE_ATTACHMENT: 'REMOVE_ATTACHMENT',
  CREATE_ATTACHMENTS: 'CREATE_ATTACHMENTS',
};

export const {
  fetchAttachmentsRequest,
  fetchAttachmentsSuccess,
  fetchAttachmentsFailure,
} = generateApiActions(types.FETCH_ATTACHMENTS);

export const {
  createAttachmentsRequest,
  createAttachmentsSuccess,
  createAttachmentsFailure,
} = generateApiActions(types.CREATE_ATTACHMENTS);

export const {
  removeAttachmentRequest,
  removeAttachmentSuccess,
  removeAttachmentFailure,
} = generateApiActions(types.REMOVE_ATTACHMENT);



// WEBPACK FOOTER //
// ./src/redux/actions/attachments.js